import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
// import {ReCaptchaV3Service} from 'ng-recaptcha';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends BaseClass<any> implements OnInit {

  loginForm!: FormGroup;
  submitted = false;
  @Output() closeLogin = new EventEmitter();
  @Output() forceChangePwd = new EventEmitter();
  passwordTextType = false;

  constructor(public service: WebserviceService,
    private fb: FormBuilder,
    private router: Router,
    private _common: CommonService,
    private _message: MessageService,
    private _shared: SharedService
  ) {
   
    super(document);
    if(localStorage.getItem(`${this.env.panel}id_token`) && localStorage.getItem(`${this.env.panel}id_token`) != null) {      
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      // termsCondition: [''],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      // if (this.f.termsCondition.errors) {
      //   this._message.errmessage("Please agree Terms and Conditions");
      // }

      // return;
    }
    let req = {
      "username": this.loginForm.value.username,
      "password": this.loginForm.value.password,
      "domain": this.env.baseUrl
    }
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(req, null, 4));
    this.login(req);
  }

  login(req: any) {
    this.isLoad = true;
    this.getServices().login(`${this.env.baseUrl + this.api.login}`, req).subscribe(
      (res) => {
        this.isLoad = false;
        if (res.status == true) {
          let expiry = new Date();
          expiry.setSeconds(expiry.getSeconds() + res.data.expires_in);

          res.data.user["role_id"] = res?.data?.region;
          localStorage.removeItem(`${this.env.panel}marquee`);
          localStorage.setItem(`${this.env.panel}marquee`, res.data.message);
          localStorage.removeItem(`${this.env.panel}user`);
          localStorage.setItem(`${this.env.panel}user`, JSON.stringify(res.data.user));
          localStorage.removeItem(`${this.env.panel}id_token`);
          localStorage.setItem(`${this.env.panel}id_token`, `${res.data.token_type} ${res.data.access_token}`);
          localStorage.removeItem(`${this.env.panel}expiry`);
          localStorage.setItem(`${this.env.panel}expiry`, `${expiry}`);
          localStorage.removeItem(`${this.env.panel}stakes`);
          localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(res.data.stakes));
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res.data.event_type_settings));
          localStorage.removeItem(`${this.env.panel}pointAcc`);
          localStorage.setItem(`${this.env.panel}pointAcc`, res.data.point_accounting);

          this.closeLogin.emit('');
          this.router.navigate(['/dashboard']);
        } else {
          if (res.error.code == 1003) {
           this._common.checkForForceChangePassword(res);
          //   localStorage.removeItem(`${this.env.panel}id_token`);
          //   localStorage.setItem(`${this.env.panel}id_token`, `${res.data.token_type} ${res.data.access_token}`);
          //   this.router.navigate(['/force-change-password'])
          } else {
            this._message.errmessage(res.error.message);
          }
        }
      },
      (err) => {
        console.log(err);
        this.isLoad = false;
        // this._message.errmessage(err.error.error);
        // this.closeLogin.emit('');
      });
  }

  togglePasswordFieldTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

}
